<template>
  <m-dialog ref="dlg" @save="save" title="Ubah Kata Sandi">
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <label class="caption">Kata sandi lama</label>
            <v-text-field
              dense
              single-line
              outlined
              autofocus
              label="Kata Sandi lama*"
              v-model="pass.old_password"
              hint="Kata Sandi Anda yang lama"
              data-vv-name="password_lama"
              data-vv-as="Kata Sandi lama"
              v-validate="'required'"
              type="password"
              :error-messages="errors.collect('form.password_lama')"
            ></v-text-field>

            <label class="caption">Kata sandi baru</label>
            <v-text-field
              dense
              single-line
              outlined
              class="mt-3"
              ref="password"
              type="password"
              label="Kata Sandi baru"
              v-model="pass.password"
              hint="Isi ulang kata sandi baru"
              data-vv-name="password"
              data-vv-as="Kata Sandi baru"
              v-validate="'required|min:6'"
              :error-messages="errors.collect('form.password')"
            ></v-text-field>

            <label class="caption">Konfirmasi kata sandi baru</label>
            <v-text-field
              dense
              single-line
              outlined
              type="password"
              label="Konfirmasi kata sandi baru"
              v-model="pass.password_confirmation"
              hint="Konfirmasi kata sandi baru"
              data-vv-name="password_confirmation"
              data-vv-as="Konfirmasi kata sandi baru"
              v-validate="'required|min:6|confirmed:password'"
              :error-messages="errors.collect('form.password_confirmation')"
            ></v-text-field>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      pass: {},
      passDef: {
        password_lama: null,
        password_baru: null,
        password_baru_confirm: null
      }
    };
  },
  mounted() {},
  computed: {},
  methods: {
    // eslint-disable-next-line
    open() {
      this.pass = { ...this.passDef };
      this.$validator.reset();
      return this.$refs.dlg.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("user/changePassword", this.pass);
        })
        .then(res => {
          this.$refs.dlg.resolve(res);
          this.$info("Kata Sandi berhasil diperbarui");
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
